module.exports = __webpack_public_path__ + "images/emoji/candy.5b9faf9a62932d268ec1.png";